const brandIdentity = require('./brand.json');

function assertBrandIdentity(value) {
  if (!/^[a-z0-9][a-z0-9-]*$/.test(value.id)) {
    throw new Error(
      'Brand id must use lowercase letters, digits, and hyphens.'
    );
  }
  if (!/^[\p{L}\p{N}][\p{L}\p{N} ._-]{0,63}$/u.test(value.displayName)) {
    throw new Error('Brand displayName contains unsafe characters.');
  }
  if (!/^@[A-Za-z0-9_]{1,32}$/.test(value.socialHandle)) {
    throw new Error('Brand socialHandle must be an @-prefixed handle.');
  }
  if (
    typeof value.wordmarkAccentSuffix !== 'string' ||
    !/^[\p{L}\p{N} _.-]*$/u.test(value.wordmarkAccentSuffix) ||
    (value.wordmarkAccentSuffix &&
      !value.displayName.endsWith(value.wordmarkAccentSuffix))
  ) {
    throw new Error('Brand wordmarkAccentSuffix must end displayName.');
  }
  const minimumWordmarkWidth =
    149 + Math.max(0, value.displayName.length - 10) * 12;
  if (
    !Number.isInteger(value.wordmarkViewBoxWidth) ||
    value.wordmarkViewBoxWidth < minimumWordmarkWidth ||
    value.wordmarkViewBoxWidth > 1024
  ) {
    throw new Error(
      `Brand wordmarkViewBoxWidth must be an integer from ${minimumWordmarkWidth} to 1024.`
    );
  }
  if (
    !Array.isArray(value.legacyDisplayNames) ||
    value.legacyDisplayNames.some(
      name =>
        typeof name !== 'string' ||
        !/^[\p{L}\p{N}][\p{L}\p{N} ._-]{0,63}$/u.test(name)
    )
  ) {
    throw new Error('Brand legacyDisplayNames contains an unsafe name.');
  }
}

assertBrandIdentity(brandIdentity);

const BRAND_IDENTITY = Object.freeze(brandIdentity);

module.exports = {
  BRAND_IDENTITY,
  BRAND_DISPLAY_NAME: BRAND_IDENTITY.displayName,
  BRAND_SOCIAL_HANDLE: BRAND_IDENTITY.socialHandle,
  BRAND_WORDMARK_ACCENT_SUFFIX: BRAND_IDENTITY.wordmarkAccentSuffix,
  BRAND_WORDMARK_VIEWBOX_WIDTH: BRAND_IDENTITY.wordmarkViewBoxWidth,
  BRAND_LEGACY_DISPLAY_NAMES: Object.freeze(BRAND_IDENTITY.legacyDisplayNames),
};
